import {BANNER} from './api'
import {METHOD, request} from '@/utils/request'

export async function getAllRotations(params) {
  return request(BANNER+"/getRotationsByStatusAndTitle", METHOD.GET, params)
}

export async function saveRotations(params) {
  return request(BANNER+"/addOneRotation", METHOD.POST, params)
}

export async function editOneRotation(params) {
  return request(BANNER+"/editOneRotation", METHOD.POST, params)
}

export async function removeRotation(params) {
  // console.info("delete",params)
  return request(BANNER+"/removeRotationById?rotationId="+params.rotationId, METHOD.POST, params)
}

export function updateStatus(params) {
  return request(BANNER+"/editRotationsByStatus", METHOD.POST,null, {params})
}

export function rotationToTop(params) {
  return request(BANNER+"/rotationToTop", METHOD.POST,null, {params})
}


export function rotationNotToTop(params) {
  return request(BANNER+"/rotationNotToTop", METHOD.POST,null, {params})
}


export default {getAllRotations,saveRotations,editOneRotation,removeRotation, updateStatus}